export enum DeviceAction {
  Reboot = 'reboot',
  RecreateSettings = 'recreateSettings',
  ReloadSettings = 'reloadSettings',
}
